import Revue from './Revue'
import Memegor from './Memegor'
import Stranding from './Stranding'
import Nichijou from './Nichijou'
import Miku from './Miku'
import Shimeji from './Shimeji'

function MerchList() {
    return (
        <>
        <div>
            <div className="flex xl:flex-row flex-col my-16 justify-between w-full gap-20">
                <div className=" md:text-8xl text-5xl font-mono">New Doujin Merch</div>
                <div className=" md:text-4xl text-xl font-mono max-w-2xl">
                    We are MemeGoreng Indonesia, We are Facebook page that specialize in Deep Fried Meme. Other than that we are just a bunch of Designer who like to experiment with digital medium
                </div>
            </div>
            <Memegor />
            <Revue />
            <Miku />
            <Shimeji />
            <Nichijou />
        </div>
        </>
    )}


export default MerchList;